import React from "react";
import { Link } from "react-router-dom";
import { getRecentBlogArticles } from "@/apis/blog-service";
import { ArticleCard } from "./ArticleCard";
import { useLanguageContext } from "@/hooks";

type RecentArticlesStripProps = {
  limit?: number;
};

export const RecentArticlesStrip: React.FC<RecentArticlesStripProps> = ({ limit = 3 }) => {
  const { language } = useLanguageContext();
  const recentArticles = getRecentBlogArticles(limit);
  const blogLabel = language("label.blog") || "Blog";
  const recentArticlesLabel = language("label.recent_articles") || "Recent Articles";
  const viewAllLabel = language("label.view_all") || "View all";

  return (
    <section className="container py-5">
      <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
        <div>
          <span className="text-uppercase kg-green fw-semibold small">{blogLabel}</span>
          <h2 className="h3 mb-0">{recentArticlesLabel}</h2>
        </div>
        <Link to="/blog" className="kg-green text-decoration-none fw-semibold text-nowrap">
          {viewAllLabel} <i className="bi bi-arrow-right ms-1" aria-hidden="true"></i>
        </Link>
      </div>
      {recentArticles.length > 0 ? (
        <div className="row g-4">
          {recentArticles.map((article) => (
            <div className="col-12 col-md-6 col-lg-4" key={article.slug}>
              <ArticleCard article={article} compact />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-muted">{language("label.no_articles_available") || "No articles available yet."}</div>
      )}
    </section>
  );
};

export default RecentArticlesStrip;
